<body class="A4">
  <!-- Page 1 -->
  <section class="sheet padding-10mm">
    <div class="d-flex align-items-center logo">
      <img [src]="logoImage"/>
    </div>
    <div class="report-name" *ngIf="selectedReport">
      {{selectedReport.name}}
    </div>
    <div class="active-filters">
      <div class="header-title">
        {{'pdf.measure.active_filters' | translate}}
      </div>
      <div class="criteria-container">
        <div class="criteria">
          <span class="main-title">{{'pdf.measure.projects' | translate}}: </span><span class="sub-title">{{reportCriteria.project_id | filterDataById : listProjectOfAdvertiser}}</span>
        </div>
        <div class="criteria">
          <span class="main-title">{{'pdf.measure.influencer_groups' | translate}}: </span><span class="sub-title">{{reportCriteria.influencerGroup | filterDataById : influencerGroups}}</span>
        </div>
        <div class="criteria">
          <span class="main-title">{{'pdf.measure.campaigns' | translate}}: </span><span class="sub-title">{{reportCriteria.campaign_id | filterDataById : campaignList}}</span>
        </div>
        <div class="criteria">
          <span class="main-title">{{'pdf.measure.platforms' | translate}}: </span><span class="sub-title"></span>
        </div>
        <div class="criteria">
          <span class="main-title">{{'pdf.measure.countries' | translate}}: </span><span class="sub-title"></span>
        </div>
        <div class="criteria">
          <span class="main-title">{{'pdf.measure.time_period' | translate}}: </span><span class="sub-title">{{previousDate| date:'MMM dd, yyyy'}} - {{currentDate | date:'MMM dd, yyyy'}}</span>
        </div>
      </div>
    </div>
    <pdf-viewer-footer></pdf-viewer-footer>
  </section>
  <!-- Page 2 -->
  <section class="sheet dynamic-height padding-10mm">
    <table>
      <thead class="header-container">
        <tr>
          <th>
            <div>
              <pdf-viewer-header [currentDate]="reportCriteria.period.formattedEndDate"
                                 [previousDate]="reportCriteria.period.formattedStartDate">
              </pdf-viewer-header>
            </div>
          </th>
        </tr>
      </thead>
      <tfoot class="footer-container">
        <tr>
          <th>
            <div class="dynamic-footer">
              <pdf-viewer-footer></pdf-viewer-footer>
            </div>
          </th>
        </tr>
      </tfoot>
      <tbody>
        <tr>
          <td id="content">
            <div class="section-content" *ngFor="let module of listModuleForPdf; let i = index">
              <measure-content [moduleId]="module"
                               [title]="getReportTitleById(module)"
                               [data]="getReportData(module, i)"
                               [pageIndex]="getReportComponentIndex(module, i)"
                               [hidden]="isHiddenSection(module)"
                               [platformList]="platformList"
                               [industryDrillDownReportPieCenter]="[25, 50]"
                               [industryDrillDownReportPieSize]="industryDrillDownReportPieSize"
                               [numberItemInRoiReport]="numberOfPostInRoiPdf"
                               [segmentInfluencerOverviewPieChartCenter]="[-5, 25]"
                               [bpIndex]="activeBenchmarkPerformance"
                               [coIndex]="activeChannelOpportunity"
                               [selectedSortType]="selectedBestPerformingInfluencerOrder"
                               (reportSettingsChange)="onReportSettingsChange($event)"
                               (reportDataChange)="onReportDataChange($event)">
              </measure-content>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
  <section class="sheet padding-10mm hidden-section">

  </section>
</body>



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/measure-pdf-viewer/measure-pdf-viewer.component.html